<template>

    <div ref="diagram" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div class="move-box">
            <div class="upmask">
                <div class="titleAll" v-if="site == ''">
                    <div class="nav">
                        <img :src="seat" alt="" />
                        <p class="inKelus">
                            <b>{{ title }}</b>
                        </p>
                    </div>
                </div>
                <div class="titleAll-nav" v-else>
                    <div class="nav">
                        <img :src="seat" alt="" />
                        <p class="inKelus">
                            <b>{{ title }}</b>
                        </p>
                    </div>
                    <div class="Op">{{ site }}</div>
                </div>
            </div>
            <!-- 此处 有个浏览器回退 的bug，但是回退 改了之后 iframe内的控制 就失效 了 -->
            <!-- <iframe name="Gis" width="100%" height="100%" ref="iframeWindow" class="small"
                :key="srcIframe" :src="srcIframe"> 

            </iframe> -->
             <iframe name="Gis" width="100%" height="100%" ref="iframeWindow" class="small"
                 :src="srcIframe"> 

            </iframe>

            <div class="clickbtn-rongt" v-if="IsNone == 1">
                <div v-if="$store.state.project.currentProject.projectId == 4">
                    <el-menu default-active="-1" class="el-menu-vertical-demo" @select="handleSelect" >
                        <el-menu-item v-if="index < 2" v-for="(item, index) in data" :key="index" :index="index"
                            @click="sendMessage(item.values)">

                            <img :src="item.src" alt="" />
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </el-menu>
                </div>
                <div v-else>
                    <el-menu default-active="-1" class="el-menu-vertical-demo" @select="handleSelect">
                        <el-menu-item v-for="(item, index) in data" :key="index" :index="index"
                            @click="sendMessage(item.values)">
                            <img :src="item.src" alt="" />
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div class="clickbtn-rongt1" v-else-if="IsNone == 2">
                <el-menu class="el-menu-vertical-demo" ref="elMenu">
                    <el-menu-item default-active="-1" v-for="(item, index) in list" :key="index" :index="index"
                        v-on:click="addClass(index, item.className)" v-bind:class="{ bgColors: index == current }" >
                        <div class="btq">
                            <img :src="item.img1" alt="" v-if="index != current" />
                            <img :src="item.img2" alt="" v-else />
                            <span slot="title">{{ item.name}}</span>
                        </div>
                        <p class="OpSp">
                            <span>{{ item.Btq }}</span><span>台</span>
                        </p>
                    </el-menu-item>
                </el-menu>
            </div>
            <router-link to="/3D" v-if="IsNone == 1 || IsNone == 2">
                <div class="Downmask1">
                    <img src="../../../assets/img/矢量智能对象.png" alt="" />
                    <p class="rouling">进入大屏显示</p>
                </div>
            </router-link>
            <div class="Downmask"></div>
        </div>
        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span>全屏</span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <!-- <img src="@/assets/img/full_cancel.png" alt="取消全屏"> -->
            <span>取消全屏</span>
        </div>
        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="margin-right: 18px">宽屏</span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="kuan = false" style="right: 20rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="">取消宽屏</span>
        </div>
    </div>

</template>
<script>
    import {
        chainIndex
    } from "../../../api/linkindex";
    // import echars from './echars.vue';
    export default {
        //   components: { echars },
        data() {
            return {
                data: [{
                        id: 1,
                        name: "概况",
                        src: require("../../../assets/img/主视角.png"),
                        values: "parkOverview",
                    },
                    {
                        id: 2,
                        name: "站房",
                        src: require("../../../assets/img/站点概览.png"),
                        values: "siteOverview",
                    },
                    {
                        id: 3,
                        name: "供电",
                        src: require("../../../assets/img/电力桥架.png"),
                        values: "electricLine",
                    },
                ],
                //一开始选中的值
                current: 4,
                //循环的数组
                list: [],
                //延时器3M
                timer: "",
                //控制
                IsNone: 0,
                kuan: false,
                isFull: false,
                url: "",
                id: 0,
                seat: require("../../../assets/img/ebs.png"),
                title: "",
                site: "",
                iframeWin: {},
            };
        },
        mounted() {
            this.IsNone = this.$store.state.homeitem.Dclick;
            this.iframeWin = this.$refs.iframeWindow.contentWindow;
                console.log(this.iframeWin);

            window.addEventListener("message", this.handleMessage);
            this.getTil();
            this.howtall();
            
            
        },
        beforeDestroy() {
            window.removeEventListener("message", this, this.handleMessage);
            clearTimeout(this.timer);

            this.$store.commit("Dclick", 1);
            this.current = 4;
            this.IsNone = 0;
        },
        watch: {
            // title(n, o) {
            //   //   console.log(n, o);
            //   this.title = n;
            // },
            srcIframe(){
                // this.iframeWin = this.$refs.iframeWindow.contentWindow;
                // window.addEventListener("message", this.handleMessage);
                // console.log(this.iframeWin);

            },
            site(n, o) {
                // console.log(n, o);
                this.site = n;
            },

            "$store.state.homeitem.areaId": function (n, o) {
                // console.log(n, o)
                this.howtall()
                if (n == null) {
                    // console.log(1111)
                } else {
                    chainIndex
                        .site(this.$store.state.project.currentProject.projectId)
                        .then((res) => {
                            if (res.data.data.areas) {
                                res.data.data.areas.forEach((item, index) => {
                                    if (item.areaId == n) {
                                        this.url = item.modelParams
                                        console.log(this.url);
                                        this.site = item.areaName
                                    }
                                })
                            }
                        })
                }
            },
            "$store.state.homeitem.Dclick": function (n, o) {
                // console.log(n,o)
                if (n == 2) {
                    // console.log(2,"============>我变成2了")
                    this.IsNone = 2;
                    chainIndex
                        .site(this.$store.state.project.currentProject.projectId)
                        .then((res) => {
                            // console.log(res.data);
                            res.data.data.areas.forEach((item) => {
                                if (item.areaId == this.$store.state.homeitem.areaId) {
                                    this.current = 4;

                                    this.site = item.areaName;
                                    this.url = item.modelParams;
                                    this.$store.commit("mantotal", item.areaName);
                                    this.$store.commit("getpng", item.areaImg);
                                    // console.log(this.url)
                                    chainIndex.breaker(item.areaId).then((res) => {
                                        this.$store.commit("voltageClasses1", res.data.data
                                            .result[0]);
                                        let abc = res.data.data.result[1];
                                        this.$store.commit("voltageClasses2", abc);
                                    });
                                }
                            });
                        });
                } else if (n == 1) {
                    //   console.log("我变成1了")
                    // @to do
                    // 地图加载完成的处理（有3秒的飞行动画）
                    this.IsNone = 1;
                    this.site = "";
                    this.url = this.$store.state.project.projectInfo.webgisUrlWhite;
                    this.$store.commit("setData", 0);
                }
            },
        },
        methods: {
            //BUs传值
            EmitItemAll() {
                // console.log(yourData);
                this.IsNone = this.$store.state.homeitem.Dclick;
            },
            //切换
            addClass(index, type) {
                this.current = index ? index : 0;
                // console.log(type)
                this.iframeWin.postMessage({
                        cmd: "showDevice",
                        type: type,
                        devices: "",
                    },
                    "*"
                );
            },

            //变压器台数
            howtall() {
                //         console.log(this.$store.state.homeitem.areaId)
                chainIndex.QueryFacility(this.$store.state.homeitem.areaId).then(res => {
                    // console.log(res.data.data.result, "<==============我是变压器数据")
                    let a = 0;
                    let b = 0;
                    let c = 0;
                    let d = 0
                    if (JSON.stringify(res.data.data) != "{}") {
                        res.data.data.result.forEach(item => {
                            if (item.type == "变压设备") {
                                a = item.num
                            }
                            if (item.type == "高压配电") {
                                b = item.num
                            }
                            if (item.type == "低压配电") {
                                c = item.num
                            }
                            if (item.type == "新能源设备") {
                                d = item.num
                            }

                        })
                    }
                    // console.log(a, b, c)
                    this.$set(this.list, 1, {
                        id: 0,
                        name: "低压配电",
                        img1: require("../../../assets/img/低压馈线柜1.png"),
                        img2: require("../../../assets/img/低压馈线柜2.png"),
                        Btq: c,
                        className: "低压配电",
                    });

                    this.$set(this.list, 0, {
                        id: 0,
                        name: "变压设备",
                        img1: require("../../../assets/img/变压器1.png"),
                        img2: require("../../../assets/img/变压器2.png"),
                        Btq: a,
                        className: "变压设备",
                    });
                    if (this.$store.state.project.currentProject.projectId != 4) {
                        this.$set(this.list, 2, {
                            id: 0,
                            name: "高压配电",
                            img1: require("../../../assets/img/低压进线柜1.png"),
                            img2: require("../../../assets/img/低压进线柜2.png"),
                            Btq: b,
                            className: "高压配电",
                        });
                    }
                    if (this.$store.state.project.currentProject.projectId == 2) {
                        this.$set(this.list, 3, {
                            id: 3,
                            name: "新能源设备",
                            img1: require("../../../assets/img/变压器1.png"),
                            img2: require("../../../assets/img/变压器2.png"),
                            Btq: d,
                            className: "新能源设备",
                        });
                    }
                })
           
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
            handleMessage(event) {
                const data = event.data;
                console.log(data);

                // console.log(data);
                switch (data.cmd) {
                    case "RealTimeData":
                        this.$emit('loopDetail', data.cmd, data.loopName)
                        break;
                    case "ThreeLoadEnd":
                        this.iframeWin.postMessage({
                                cmd: "noDetailUI",
                            },
                            "*"
                        );
                        break;
                    case "loadEnd":
                        if (this.$store.state.homeitem.Dclick == 2) {
                            // console.log(111111111111, "if")
                            this.IsNone = 2;
                            this.$store.commit("setData", 1);
                            chainIndex
                                .site(this.$store.state.project.currentProject.projectId)
                                .then((res) => {
                                    // console.log(res.data.data.areas);
                                    res.data.data.areas.forEach((item) => {
                                        this.current = 4;
                                        this.site = item.areaName;
                                        // console.log(item.modelParams)
                                        this.url = item.modelParams;
                                        this.$store.commit("mantotal", item.areaName);
                                        this.$store.commit("getpng", item.areaImg);
                                        chainIndex.breaker(item.areaId).then((res) => {
                                            this.$store.commit(
                                                "voltageClasses1",
                                                res.data.data.result[0]
                                            );
                                            let abc = res.data.data.result[1];
                                            this.$store.commit("voltageClasses2", abc);
                                        });
                                    });
                                });
                        } else {
                            // @to do
                            // 地图加载完成的处理（有3秒的飞行动画）
                            // console.log(2222222222, "else")
                            this.IsNone = 1;
                            this.$store.commit("setData", 0);
                            this.site = "";

                        }

                        break;
                    case "returnData":
                        this.id = this.$store.state.project.currentProject.projectId;
                        chainIndex.loopAll(this.id).then((res) => {
                            // console.log(res.data.data, "订阅");
                            let mqtt = res.data.data.loops.map((item) => item.subLoopUrl);
                            // console.log(mqtt)
                            this.$store.commit("fomeitem", mqtt);
                        });
                        let val = data.params.data;
                        this.$store.commit("webId", data.params.data.id)

                        if (this.$store.state.project.currentProject.projectId == 2) {
                            if (data.params.data.id == 3) {
                                this.$store.commit("webId", data.params.data.id)
                                this.$store.commit("setData", 1);
                                this.IsNone = 2;
                                chainIndex
                                    .site(this.$store.state.project.currentProject.projectId)
                                    .then((res) => {
                                        // console.log(res.data);
                                        this.current = 4;
                                        res.data.data.areas.forEach((item) => {
                                            if (data.params.data.id == item.areaId) {
                                                this.site = item.areaName;
                                                this.url = item.modelParams;
                                                this.$store.commit("mantotal", item.areaName);
                                                this.$store.commit("getpng", item.areaImg);
                                                //进线断路器传参
                                                chainIndex.breaker(item.areaId).then((res) => {
                                                    this.$store.commit(
                                                        "voltageClasses1",
                                                        res.data.data.result[0]
                                                    );
                                                    let abc =
                                                        res.data.data.result[1];
                                                    this.$store.commit("voltageClasses2", abc);
                                                });
                                            }
                                        });
                                        // console.log(data);
                                    });
                            } else {
                                this.$store.commit("webId", data.params.data.id)
                                this.$store.commit("setData", 2);
                                this.$store.commit("Dthere", 2);
                                this.IsNone = 2;
                                chainIndex
                                    .site(this.$store.state.project.currentProject.projectId)
                                    .then((res) => {
                                        // console.log(res.data);
                                        this.current = 4;
                                        res.data.data.areas.forEach((item) => {
                                            if (data.params.data.id == item.areaId) {
                                                this.site = item.areaName;
                                                this.url = item.modelParams;
                                                this.$store.commit("mantotal", item.areaName);
                                                this.$store.commit("getpng", item.areaImg);
                                                //进线断路器传参
                                                chainIndex.breaker(item.areaId).then((res) => {
                                                    this.$store.commit(
                                                        "voltageClasses1",
                                                        res.data.data.result[0]
                                                    );
                                                    let abc =
                                                        res.data.data.result[1];
                                                    this.$store.commit("voltageClasses2", abc);
                                                });
                                            }
                                        });
                                        // console.log(data);
                                    });
                            }
                        } else {
                            if (data.params.data.id) {
                                this.$store.commit("Dthere", 2);
                                // console.log(data.params.data.id);
                                this.IsNone = 2;
                                this.$store.commit("setData", 1);
                                chainIndex
                                    .site(this.$store.state.project.currentProject.projectId)
                                    .then((res) => {
                                        //   console.log(res.data);
                                        this.current = 4;
                                        res.data.data.areas.forEach((item) => {
                                            if (data.params.data.id == item.areaId) {
                                                this.site = item.areaName;
                                                this.url = item.modelParams;
                                                this.$store.commit("mantotal", item.areaName);
                                                this.$store.commit("getpng", item.areaImg);
                                                //进线断路器传参
                                                chainIndex.breaker(item.areaId).then((res) => {
                                                    this.$store.commit(
                                                        "voltageClasses1",
                                                        res.data.data.result[0]
                                                    );
                                                    let abc =

                                                        res.data.data.result[1];
                                                    this.$store.commit("voltageClasses2", abc);
                                                });
                                            }
                                        });
                                        // console.log(data);
                                    });
                            }

                            // else {
                            //   this.IsNone = 1;
                            //   this.$store.commit("setData", 0);
                            //     this.$store.commit("Dthere", 1);
                            //   this.site = "";
                            // }
                        }

                        // @to do
                        // 点击中心配电房，返回区域ID，然后通过区域Id处理逻辑（三维换掉，按钮换掉，顶部添加站点名字）

                        break;
                    case "changeDevice":
                        console.log('rest');
                        this.current = 4
                        this.$refs.elMenu.activeIndex = null
                        break;
                }
            },
            // @to do
            // 清除事件
            sendMessage(value) {
                // console.log(value);
                this.iframeWin.postMessage({
                        cmd: "clearElectricLine",
                    },
                    "*"
                );
                this.iframeWin.postMessage({
                        cmd: "clearSiteOverview",
                    },
                    "*"
                );
                this.iframeWin.postMessage({
                        cmd: "clearParkOverview",
                    },
                    "*"
                );
                this.iframeWin.postMessage({
                        cmd: value,
                    },
                    "*"
                );
            },
            // sendMessage() {
            //   console.log(this.$refs.iframeWindow.contentWindow);
            // },

            //title
            getTil() {
                chainIndex
                    .getData(this.$store.state.project.currentProject.projectId)
                    .then((res) => {
                        // console.log(res.data.data);
                        this.title = res.data.data.project.projectName;
                        this.seat = res.data.data.project.projectIcon;
                    });
            },

            full() {
                this.isFull = true;
            },
            cancelFull() {
                this.isFull = false;
                this.reset();
            },

            onkuan() {
                this.kuan = true;
            },
            
        },
        computed: {
            kuanStyle() {
                if (this.kuan) {
                    return `
                        width: 84%;
                        height:90%;
                        position: fixed;
                        top: 6%;
                        left: 14%;
                        bottom: 0;
                        right: 0;
                        margin: auto;
                        z-index: 9999;
                    `;
                }
                return;
            },
            srcIframe(){
                let  src=  this.url?this.url : this.$store.state.project.projectInfo.webgisUrlWhite
                // let  src=  'http://127.0.0.1:5503/Apps/Sandcastle/gallery/lutai_web_white.html'
                return src
            }
        },
    };
</script>
<style lang="less" scoped>
/deep/.clickbtn-rongt1 .el-menu-item:focus{
    background-color: #fff !important;
}
    #ifromD {
        width: 100%;
        height: 100%;
    }

    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;
    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background-color: rgba(0, 0, 0, 0);
    }

    /*定义滚动条轨道 内阴影+圆角*/


    .detail {
        font-size: 18rem;
        color: #fff;
        position: absolute;
        top: 24rem;
        left: 24rem;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .tableContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #000000;
    }

    .small,
    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        /*transition: all 0.1s;*/
    }

    .mask {
        width: 100%;
        height: 100%;
    }

    .btn {
        position: absolute;
        bottom: 22rem;
        right: 24rem;
        color: #ffffff;
        font-size: 20rem;
        cursor: pointer;
    }

    .upmask {
        height: 90rem;
        position: absolute;
        width: 100%;
        z-index: 9;
        background-image: linear-gradient(rgb(0, 0, 0, 1), rgba(0, 0, 0, 0));

        .titleAll {
            position: relative;
            text-decoration: none;
            width: 296px;
            height: 48px;
            font-size: 16px;
            color: #333333;
            margin: auto;
            align-items: center;

            white-space: pre-wrap;
            word-wrap: break-word;
            display: flex;
            align-items: center;
            justify-content: center;

            .nav {
                display: flex;
                // width: 272rem;
                font-size: 16px;
                color: #333333;
                // margin: auto;
                justify-content: center;
                align-items: center;
                // height: 40rem;
            }

            img {
                width: 16px;
                height: 16px;
            }

            p {
                margin-left: 10rem;
                color: #333333;
            }
        }

        .titleAll::before {
            content: "";
            position: absolute;
            top: -10px;
            left: 0;
            right: 0;
            bottom: -20px;
            background: #fff;
            border: 1px solid #ededed;
            border-top: none;
            border-radius: 0 0 15px 15px;
            // box-shadow: 3px -3px 5px #ededed;
            transform: perspective(30px) scale(0.9, 0.7) rotateX(-7deg);
            z-index: -1;
            color: #333333;
        }

        .titleAll-nav {
            position: relative;
            text-decoration: none;
            width: 296px;
            height: 59px;
            font-size: 16px;
            color: #666;
            margin: auto;
            align-items: center;

            white-space: pre-wrap;
            word-wrap: break-word;
            padding: 10px 0;

            p {
                margin-left: 10rem;
                color: #333333;
            }

            .nav {
                display: flex;
                // width: 272rem;
                font-size: 16px;
                color: #666;
                // margin: auto;
                justify-content: center;
                align-items: center;
                // height: 40rem;
            }

            img {
                width: 16px;
                height: 16px;
            }
        }

        .titleAll-nav::before {
            content: "";
            position: absolute;
            top: -10px;
            left: 0;
            right: 0;
            bottom: 0;
            background: #fff;
            border: 1px solid #ededed;
            border-top: none;
            border-radius: 0 0 15px 15px;
            // box-shadow: 3px -3px 5px #ededed;
            transform: perspective(30px) scale(0.9, 1.1) rotateX(-7deg);
            z-index: -1;
        }

        .Op {
            text-align: center;
            font-size: 12px;
        }
    }

    .Downmask {
        height: 70rem;
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 0;
        background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 1));
    }

    .Downmask1 {
        height: 43px;
        position: absolute;
        width: 157px;
        bottom: 100rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Downmask1:hover {
        background-color: rgba(102, 160, 207, 0.9);
    }

    .rouling {
        width: 87px;
        height: 13px;
        font-size: 16px;
        font-family: "YouSheBiaoTiHei";
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        white-space: nowrap;
        margin-left: 7rem;
    }

    .clickbtn-rongt {
        height: 188px;
        position: absolute;
        width: 56px;
        top: 0;
        bottom: 0;
        margin: auto;
        left: 24px;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;

        .el-menu {
            height: 215px;
            width: 65px;
            z-index: 0;
            border-radius: 12px;
            display: grid;
            align-items: center;
            justify-items: center;
        }

        .el-menu-item {
            width: 100%;
            // height:100%;
            white-space: pre-wrap;
            word-wrap: break-word;
            display: grid;
            border-radius: 10px;
            align-items: center;
            justify-items: center;
            padding-left: 0px !important;
            padding: 0;
            line-height: 0;

            img {
                // margin: 0 40px 0 10px;
                width: 24px;
                height: 20px;
            }

            span {
                // margin: 0 40px 0 10px;
                padding-bottom: 10px !important;
                font-size: 14px;
            }
        }
    }

    .clickbtn-rongt1 {
        height: 104px;
        width: 167px;
        position: absolute;

        top: 0;
        bottom: 0;
        margin: auto;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        display: flex;

        .el-menu {
            overflow-y: scroll;
            overflow-x: hidden;
            height: 100px;
            width: 167px;
            z-index: 0;
            border-radius: 12px;
            display: grid;
            // justify-content: center;
            // align-items: center;
            padding-left: 1px !important;
            padding:10rem 0 0 0;
            line-height: 0;
        }

        .el-menu::-webkit-scrollbar {
            width: 1px !important;
        }

        .el-menu-item {
            padding: 0 10px;
            white-space: pre-wrap;
            word-wrap: break-word;
            width: 167px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btq {
                white-space: nowrap;
                font-size: 15px;
                font-weight: 400;
                margin-left: -10px;

                img {
                    width: 18px;
                    height: 18px;
                }

                span {
                    margin-left: 10px;
                }
            }
            p {
                font-size: 15rem;
                margin-left: 30rem;
                font-weight: 400;
            }
        }

        .el-menu-item:focus,
        .el-menu-item:hover {
            outline: 0;
            background: rgba(13, 148, 255, 0.12);
            border-radius: 12px;
           padding: 0 10px;
            white-space: pre-wrap;
            word-wrap: break-word;
            width: 167px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .OpSp {
            display: flex;
            width: 30px;

            white-space: nowrap;
        }
    }
</style>